import { Link, useParams } from 'react-router-dom';
import PageTitle from '../components/pagetitle/PageTitle';
import Footer from '../components/footer/Footer';
import Sidebar from '../components/sidebar/Sidebar';
import dataBlog from '../assets/fake-data/data-blog';

function renderBlock(block, i) {
  switch (block.type) {
    case 'intro':
      return <p key={i} className="boild">{block.text}</p>;
    case 'heading':
      return <h5 key={i} style={{ color: '#dec7ff', margin: '32px 0 12px', fontWeight: 700 }}>{block.text}</h5>;
    case 'paragraph':
      return <p key={i} className="mb-15">{block.text}</p>;
    case 'list':
      return (
        <ul key={i} style={{ paddingLeft: '20px', marginBottom: '16px' }}>
          {block.items.map((item, j) => (
            <li key={j} style={{ color: '#e0e0e0', marginBottom: '8px', lineHeight: 1.7 }}>{item}</li>
          ))}
        </ul>
      );
    case 'code':
      return (
        <pre key={i} style={{
          background: '#12132a',
          border: '1px solid rgba(92,39,254,0.3)',
          borderRadius: '8px',
          padding: '20px',
          overflowX: 'auto',
          marginBottom: '20px',
          fontSize: '13px',
          lineHeight: 1.6,
          color: '#dec7ff',
          fontFamily: '"Fira Code", "Menlo", monospace',
        }}>
          <code>{block.text}</code>
        </pre>
      );
    case 'quote':
      return (
        <blockquote key={i} style={{
          borderLeft: '3px solid #5c27fe',
          paddingLeft: '20px',
          margin: '24px 0',
          fontStyle: 'italic',
          color: 'rgba(222,199,255,0.8)',
          fontSize: '15px',
          lineHeight: 1.7,
        }}>
          {block.text}
        </blockquote>
      );
    default:
      return null;
  }
}

function BlogDetails() {
  const { slug } = useParams();
  const blog = dataBlog.find((b) => b.slug === slug);
  const otherBlogs = dataBlog.filter((b) => b.slug !== slug);

  if (!blog) {
    return (
      <div className="wrapper">
        <section className="bloglist">
          <div className="container" style={{ textAlign: 'center', padding: '100px 0' }}>
            <h3>Blog post not found.</h3>
            <Link to="/blog" className="action-btn" style={{ marginTop: 24, display: 'inline-block' }}>
              <span>Back to Blog</span>
            </Link>
          </div>
        </section>
        <Footer />
      </div>
    );
  }

  return (
    <div className="wrapper">
      <PageTitle title="Blog Details" />

      <section className="bloglist">
        <div className="container">
          <div className="row">
            <div className="bloglist__main">
              <div className="list details">

                <h4 className="title">{blog.title}</h4>

                <p>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 6 }}>
                    <path d="M2.9375 0.75V2.0625M9.0625 0.75V2.0625M0.75 9.9375V3.375C0.75 3.0269 0.888281 2.69306 1.13442 2.44692C1.38056 2.20078 1.7144 2.0625 2.0625 2.0625H9.9375C10.2856 2.0625 10.6194 2.20078 10.8656 2.44692C11.1117 2.69306 11.25 3.0269 11.25 3.375V9.9375M0.75 9.9375C0.75 10.2856 0.888281 10.6194 1.13442 10.8656C1.38056 11.1117 1.7144 11.25 2.0625 11.25H9.9375C10.2856 11.25 10.6194 11.1117 10.8656 10.8656C11.1117 10.6194 11.25 10.2856 11.25 9.9375M0.75 9.9375V5.5625C0.75 5.2144 0.888281 4.88056 1.13442 4.63442C1.38056 4.38828 1.7144 4.25 2.0625 4.25H9.9375C10.2856 4.25 10.6194 4.38828 10.8656 4.63442C11.1117 4.88056 11.25 5.2144 11.25 5.5625V9.9375" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  {blog.time}
                  <span style={{ margin: '0 12px', opacity: 0.4 }}>·</span>
                  <span style={{ color: '#dec7ff' }}>{blog.category}</span>
                  <span style={{ margin: '0 12px', opacity: 0.4 }}>·</span>
                  <span style={{ opacity: 0.6 }}>{blog.readTime}</span>
                </p>

                <div className="line"></div>

                <div className="content-d">
                  <div className="main">
                    <div className="image" style={{ marginBottom: 32 }}>
                      <img src={blog.img} alt={blog.title} style={{ borderRadius: 12, width: '100%' }} />
                    </div>

                    {blog.content.map((block, i) => renderBlock(block, i))}

                    <div className="line"></div>

                    <div className="bottom">
                      <p>Tags:</p>
                      <ul className="list-tag">
                        {blog.tags.map((tag) => (
                          <li key={tag}><Link to="/blog">{tag}</Link></li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>

                {otherBlogs.length > 0 && (
                  <div className="bottom">
                    <div className="recent">
                      {otherBlogs.slice(0, 2).map((other, i) => (
                        <div key={other.id} className={`ac ${i === 0 ? 'prev' : 'next'}`}>
                          {i === 0 && (
                            <svg width="20" height="36" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.75 16.5L1.25 9L8.75 1.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          )}
                          <div>
                            <div className="meta">
                              <Link to={`/blog/${other.slug}`}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: 4 }}>
                                  <path d="M2.9375 0.75V2.0625M9.0625 0.75V2.0625M0.75 9.9375V3.375C0.75 3.0269 0.888281 2.69306 1.13442 2.44692C1.38056 2.20078 1.7144 2.0625 2.0625 2.0625H9.9375C10.2856 2.0625 10.6194 2.20078 10.8656 2.44692C11.1117 2.69306 11.25 3.0269 11.25 3.375V9.9375M0.75 9.9375C0.75 10.2856 0.888281 10.6194 1.13442 10.8656C1.38056 11.1117 1.7144 11.25 2.0625 11.25H9.9375C10.2856 11.25 10.6194 11.1117 10.8656 10.8656C11.1117 10.6194 11.25 10.2856 11.25 9.9375M0.75 9.9375V5.5625C0.75 5.2144 0.888281 4.88056 1.13442 4.63442C1.38056 4.38828 1.7144 4.25 2.0625 4.25H9.9375C10.2856 4.25 10.6194 4.38828 10.8656 4.63442C11.1117 4.88056 11.25 5.2144 11.25 5.5625V9.9375" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {other.time}
                              </Link>
                            </div>
                            <Link to={`/blog/${other.slug}`} className="title">{other.title}</Link>
                          </div>
                          {i === 1 && (
                            <svg width="20" height="36" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

              </div>

              <Sidebar />

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default BlogDetails;
